import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Checkbox,
  Button,
  Stack
} from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

export default function ConfirmCoupon({couponCode,RemoveCoupon, setConfirmRemoveCouponflag,fullObjectRewardCart,setConsent}) {
  const [checked, setChecked] = useState(false);
    const reward=fullObjectRewardCart&&fullObjectRewardCart?.data?.reward
    const amount =
      reward?.type === "freegift"
        ? reward?.amount
        : reward?.count;
    const unit =
      reward?.type === "cashback" || reward?.type === "freegift"
        ? "rupees on this order"
        : "on your final bill";
  return (
    <div style={{ position: "absolute", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center",width:"100%",background:"rgba(0,0,0,0.2)",zIndex:999999999999 }}>
    <div  >
    <Card
   
      sx={{
        width: 340,
        borderRadius: 4,
        p: 3,
        boxShadow: "0 6px 20px rgba(0,0,0,0.15)"
      }}
    >
      <Typography variant="h6" textAlign="center" fontWeight="600" mb={2}>
        Confirm Coupon Benefits
      </Typography>

      {/* Coupon Box */}
      <Box
        sx={{
          background: "#F1EAD2",
          borderRadius: 3,
          p: 2,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: 2
        }}
      >
        <LocalOfferIcon sx={{ color: "#12A150" }} />

        <Box>
          <Typography fontWeight="600" color="#12A150">
            Applied Coupon: {couponCode}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            You saved <b>₹{amount}</b> {unit}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ borderBottom: "1px solid #e0e0e0", mb: 2 }} />

      {/* Checkbox */}
      <Stack direction="row" alignItems="flex-start" spacing={1.5} mb={3}>
        <Checkbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          sx={{
            color: "#12A150",
            "&.Mui-checked": { color: "#12A150" }
          }}
        />

        <Typography variant="body2" color="text.secondary">
          I consent to receive promotional updates and exclusive offers
          from the brand shown above.
        </Typography>
      </Stack>

      {/* Buttons */}
      <Stack direction="row" spacing={2}>
        <Button
          fullWidth
          variant="outlined"
          sx={{
            borderRadius: "20px",
            borderColor: "#12A150",
            color: "#12A150",
            textTransform: "none"
          }}
        onClick={(e) => RemoveCoupon()}
        >
          No, Remove
        </Button>

  <Button
  fullWidth
  variant="contained"
  disabled={!checked}
onClick={(e)=>{setConsent(false)}}
  
  sx={{
    borderRadius: "20px",
    textTransform: "none",
    backgroundColor: "#12A150",
    "&:hover": {
      backgroundColor: "#0e8a44"
    },
    "&.Mui-disabled": {
      backgroundColor: "#9e9e9e",
      color: "#fff"
    }
  }}
>
  Yes, Continue
</Button>
      </Stack>
    </Card>
    </div>
    </div>
  );
}